<template>
  <v-btn
    class="button-wrapper"
    height="auto"
    color="primary"
    @click="onClick"
    :disabled="disabled"
    outlined
    rounded
    style="min-width: 100%;"
  >
    {{ text }}
  </v-btn>
</template>
<script>
export default {
  name: 'MultiLineButton',
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>
<style lang="sass" scoped>
::v-deep .v-btn__content
  width: 100%
  word-break: break-word
  white-space: normal
  padding-top: 6px
  padding-bottom: 6px
</style>
